import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ASSETS_HOST } from '@sorare/core/src/config';

export const useDefaultStadiumBackground = (sport: Sport) => {
  if (sport === Sport.FOOTBALL) {
    return `${ASSETS_HOST}/backgroundshopitem/0.png`;
  }
  return null;
};
